/* angular:styles/component:css;6bbdb0641deed6cbb79cdc3cf0b44fbd09e71c61027ed26dbddda4939a39542f;/src/src/app/shared/components/formly/formly-select/formly-select-with-image-modal/select-with-image-modal.component.ts */
ion-label {
  white-space: normal;
}
.option-image-container {
  margin: 0.5rem 0;
  border-radius: 0.5rem;
  overflow: hidden;
  max-width: 12.5rem;
}
.option-image {
  width: 100%;
  height: auto;
}
.option-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  white-space: normal;
}
.doc-link {
  font-size: 0.9em;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
/*# sourceMappingURL=select-with-image-modal.component.css.map */
